import { render, staticRenderFns } from "./OrderItemEditDialog.vue?vue&type=template&id=18ff6ef6&scoped=true"
import script from "./OrderItemEditDialog.vue?vue&type=script&lang=js"
export * from "./OrderItemEditDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18ff6ef6",
  null
  
)

export default component.exports